'use client';

import { useState } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ArrivalOrderTabPreview } from './_components/arrival-order-tab-preview.component';
import { SearchCardArrivalOrderModal } from './search-card-arrival-order-modal.component';

import { ArrivalOrderSlotsGrid } from '@/app/(main)/(pages)/_components/schedules/arrival-order/arrival-order-slots-grid.component';
import { useIsGreaterThan } from '@/hooks/use-is-greather-than.hook';
import { useSlotFilters } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-slot-filters.hook';
import { ScheduleType, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { sumProcedurePrices } from '@/utils/procedures/procedures.util';

const CARD_ARRIVAL_ORDER_DAYS = 3;

interface SearchCardTabArrivalOrderProps {
  schedule: SearchPartnerData;
  scheduleType?: ScheduleType;
}

export function SearchCardTabArrivalOrder({
  schedule,
  scheduleType = ScheduleType.ARRIVAL_ORDER,
}: SearchCardTabArrivalOrderProps) {
  const isWideScreen = useIsGreaterThan('xl');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scheduleId = schedule.schedulesTypes[scheduleType]?.[0]?.id;

  const slotFilters = useSlotFilters();

  if (isWideScreen) {
    return (
      <div data-testid={DataTestIdEnum.SEARCH_CARD_TAB_ARRIVAL_ORDER}>
        <ArrivalOrderSlotsGrid
          scheduleId={scheduleId}
          limitDays={CARD_ARRIVAL_ORDER_DAYS}
          partnerId={schedule.partner.id}
          price={sumProcedurePrices(schedule.procedures)}
          onSeeMore={() => setIsModalOpen(true)}
          slotFilters={slotFilters}
        />
        <SearchCardArrivalOrderModal
          scheduleId={scheduleId}
          schedule={schedule}
          open={isModalOpen}
          onOpenChange={setIsModalOpen}
        />
      </div>
    );
  }

  return <ArrivalOrderTabPreview schedule={schedule} scheduleType={scheduleType} />;
}
